import { renderMessage, renderProductTestPage, renderQuiz } from "./render.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bhpf").forEach(initProductFinder);
});

function initProductFinder(root) {
  const dataNode = root.querySelector(".bhpf__data");
  const app = root.querySelector(".bhpf__app");

  if (!dataNode || !app) {
    return;
  }

  let quiz;
  try {
    quiz = JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error(error);
    renderMessage(app, "Unable to load this product finder.");
    return;
  }

  if (quiz.product_test) {
    renderProductTestPage(app, quiz);
    return;
  }

  renderQuiz(app, quiz, {}, 0, false);
}
